package meineglasfaser.frontend.www.components.sections

import androidx.compose.runtime.Composable

@Composable
fun RegisterFooter() {
    ShopFooter()
}
